import React from 'react';
import WebsiteUpdateNotice from './WebsiteUpdateNotice';

function App() {
  return <WebsiteUpdateNotice />;
}

export default App;
